import Field from '../field/field.m.js';

export default class TextareaField extends Field {
	constructor(...args) {
		const _ = super(...args);
		return _;
	}

	setup() {
		super.setup();

		this._setDefaults();

		this.syncProp('rows');
		this.syncProp('cols');
		this.syncProp('wrap');
		this.syncProp('mode');
	}

	static get observedAttributes() {
		return super.observedAttributes.concat(['rows', 'cols', 'wrap', 'mode']);
	}

	_setDefaults() {
		this._mode = 'action';
	}

	propertyChangedCallback(name, oldValue, newValue) {
		super.propertyChangedCallback(name, oldValue, newValue);

		if (name == 'mode' ) {
			this.render();
		}
	}

	getPropertyType(name) {
		if (name == 'rows' || name == 'cols') {
			return 'number';
		} else if (name == 'mode') {
			return 'string';
		}
		return super.getPropertyType(name)
	}

	template() {
		return `
			${this.shadowRoot ? this.styles() : ''}
			<label class="${this.shadowClass}" style="position: relative;">	
				<span label>${this.label || ''}</span>
				<span field class="${this.iconClass}">
					<textarea input ${this.renderAttributes(['name', 'disabled', 'placeholder', 'type', 'form', 'list', 'autofocus', 'autocomplete', 'readonly', 'required', 'zsTabindex', 'pattern', 'min', 'max', 'step', 'checked', 'minlength', 'maxlength', 'size', 'multiple', 'alt', 'height', 'width', 'rows', 'cols', 'wrap'])}>${this.value || ''}</textarea>
					<a clear class="${this.clearIconClass}" ${this.mode == 'classic' ? 'tabindex="-1"': ''} ${!this.isClearVisible ? ` hidden` : ''} href="#" onclick="return false;"></a>
				</span>
			</label>
		`
	}

	get clearIconClass() {
        return (this.mode == 'action') ? 'zs-icon zs-icon-close-circle-fill  zs-interactive-primary' : 'zs-icon zs-icon-remove';
    }
}

// Initial tag and is
TextareaField.is = 'zs-textarea';
TextareaField.tagName = 'p';